import { useLocation } from 'history-slice/selectors';
import { useHistoryApi } from 'history-slice/actions';

const Navbar = ({ routes = [] }) => {
  const location = useLocation();
  const { push } = useHistoryApi();
  return routes.map(({ path, label: Label, description }) => (
    <a
      key={path}
      className={`btn ${location.hash !== path ? 'btn-ghost' : ''} text-xl`}
      title={description}
      onClick={() => location.hash !== path && push(path)}
    >
      {typeof Label === 'string' ? Label : <Label />}
    </a>
  ));
};

export default Navbar;
